import { useState, useEffect } from "react";
import SuperAdminLogin from "./SuperAdminLogin";
import SuperAdminDashboard from "./SuperAdminDashboard";

const SuperAdminApp = () => {
  const [token, setToken] = useState(localStorage.getItem("sa_token"));
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (token && !user) {
      const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
      fetch(`${API}/superadmin/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(r => { if (!r.ok) throw new Error(); return r.json(); })
        .then(data => setUser(data))
        .catch(() => { localStorage.removeItem("sa_token"); setToken(null); });
    }
  }, [token, user]);

  const handleLogin = (newToken, userData) => {
    setToken(newToken);
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem("sa_token");
    setToken(null);
    setUser(null);
  };

  if (!token) return <SuperAdminLogin onLogin={handleLogin} />;
  if (!user) return (
    <div className="min-h-screen bg-[#0a0a0f] flex items-center justify-center">
      <div className="text-white/40">Caricamento...</div>
    </div>
  );

  return <SuperAdminDashboard token={token} user={user} onLogout={handleLogout} />;
};

export default SuperAdminApp;
